import type { Transition, Variants } from "motion/react";
import type { TemplateCreationStep } from "../template-creation-wizard-state.js";

export const TEMPLATE_WIZARD_STEP_OFFSET_PX = 16;

export const TEMPLATE_WIZARD_STEP_ORDER: Record<TemplateCreationStep, number> = {
  DEFINITION: 0,
  EDIT: 1,
  REVIEW: 2,
};

export type TemplateWizardStepDirection = 1 | -1;

export function templateWizardStepDirection(
  from: TemplateCreationStep,
  to: TemplateCreationStep,
): TemplateWizardStepDirection {
  const delta = TEMPLATE_WIZARD_STEP_ORDER[to] - TEMPLATE_WIZARD_STEP_ORDER[from];
  return delta >= 0 ? 1 : -1;
}

export function templateWizardStepMotion(
  direction: TemplateWizardStepDirection,
  options: { isRtl: boolean; reduceMotion: boolean },
): { variants: Variants; transition: Transition } {
  if (options.reduceMotion) {
    return {
      variants: {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
      },
      transition: { duration: 0 },
    };
  }

  const flow = direction * (options.isRtl ? -1 : 1);
  const enterX = flow * TEMPLATE_WIZARD_STEP_OFFSET_PX;
  const exitX = -enterX;

  return {
    variants: {
      initial: { opacity: 0, x: enterX },
      animate: { opacity: 1, x: 0 },
      exit: { opacity: 0, x: exitX },
    },
    transition: { duration: 0.22, ease: [0.22, 1, 0.36, 1] },
  };
}
